export enum DevicePlatform {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet',
}
